import { ReactNode, createContext, useContext, useState } from "react";

// 회원기본정보 등록 Params Context
export interface initialCreateParamsProps {
  lodGrpNo: string;
  manSurnm: string;
  manFstnm: string;
  manEmlId: string;
  mobCntyCd: string;
  mobNo: string;
}

interface BaseJoinParamContextType {
  param: initialCreateParamsProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onReset: () => void;
}

const BaseJoinParamContext = createContext<
  BaseJoinParamContextType | undefined
>(undefined);

interface BaseJoinParamProviderProps {
  children: ReactNode;
}

export const BaseJoinParamProvider = ({
  children,
}: BaseJoinParamProviderProps) => {
  const initialFilterState = {
    lodGrpNo: "",
    manSurnm: "",
    manFstnm: "",
    manEmlId: "",
    mobCntyCd: "+82",
    mobNo: "",
  };

  const [param, setParam] =
    useState<initialCreateParamsProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setParam({
      ...param,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string | any) => {
    setParam({
      ...param,
      [name]: value,
    });
  };

  const onReset = () => {
    setParam(initialFilterState);
  };

  return (
    <BaseJoinParamContext.Provider
      value={{
        param,
        onChange,
        onSelect,
        onReset,
      }}
    >
      {children}
    </BaseJoinParamContext.Provider>
  );
};

export const useBaseJoinParamContext = (): BaseJoinParamContextType => {
  const context = useContext(BaseJoinParamContext);

  if (!context) {
    throw new Error(
      "useBaseJoinParamContext는 BaseJoinParamProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
